import React from 'react';
import { Tag, Zap, Timer } from 'lucide-react';

const SortButtons = ({ sortBy, setSortBy }) => {
  const sortOptions = [
    { id: 'price', label: 'Cheapest', icon: Tag },
    { id: 'duration', label: 'Fastest', icon: Zap },
    { id: 'departure', label: 'Earliest', icon: Timer }
  ];

  return (
    <div className="hidden lg:flex items-center gap-2">
      {sortOptions.map((sort) => {
        const Icon = sort.icon;
        return (
          <button
            key={sort.id}
            onClick={() => setSortBy(sort.id)}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all flex items-center gap-1.5 ${
              sortBy === sort.id
                ? 'bg-teal-600 text-white shadow-md'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            <Icon className="w-4 h-4" />
            {sort.label}
          </button>
        );
      })}
    </div>
  );
};

export default SortButtons;